<template>
    <div class="tabs-users panel panel-default">
        <ul class="nav nav-tabs">
            <li :class="{active: activated == 1}">
                <a @click="activated = 1">
                    Активные
                </a>
            </li>
            <li :class="{active: activated == 0}">
                <a @click="activated = 0">
                    Неактивные
                </a>
            </li>
        </ul>

        <list-users activated="1" v-show="activated == 1"></list-users>
        <list-users activated="0" v-show="activated == 0"></list-users>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        activated: 1,
      }
    },
  }
</script>


// WEBPACK FOOTER //
// TabsUsers.vue?69bbc982